import Component from 'component';
import ImageCompare from 'image-compare-viewer/dist/image-compare-viewer.min';
import { BREAKPOINT } from '../constants';
import ModalBeforeAfter from './ModalBeforeAfter';

class BeforeAfter extends Component {
  constructor(el) {
    super(el);
    this.initSlick();
  }

  setupDefaults() {
    this.dom = {
      $slider: this.$el.find('.before-after__slider'),
      $sliderContent: this.$el.find('.before-after__slider-content'),
      $dotsContainer: this.$el.find('.before-after__dots'),
      $sliderSlides: this.$el.find('.before-after__slider__slide')
    };
    new ModalBeforeAfter($('.btn__open-modal'), this.$el.data('mobileClose') || '');
  }

  setupImageCompare() {
    Array.from(document.querySelectorAll('.featured-compare-before-after'))
      .forEach(el => {
        new ImageCompare(el,
          {
            controlColor: '#CB4510',
            showLabels: false,
            controlShadow: false,
            addCircle: true,
            addCircleBlur: false
          }
        ).mount();
      })
  }


  initSlick() {
    const prevArrow = this.$el.find('.before-after__pagination .slick-prev');
    const nextArrow = this.$el.find('.before-after__pagination .slick-next');
    // Create TwentyTwenty instance after slick complete its calculations
    this.dom.$slider.on('init', () => {
      this.setupImageCompare();
    })
    // Create images slider
    this.dom.$slider.slick({
      infinite: true,
      dots: false,
      draggable: false,
      centerMode: true,
      centerPadding: '14.43%',
      prevArrow,
      nextArrow,
      customPaging: (slider, i) => $('<button type="button" />').text(i + 1),
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: false,
      responsive: [
        {
          breakpoint: BREAKPOINT.desktop,
          settings: {
            centerMode: true,
            draggable: false,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    })
    this.createPagination(0)
    // Update Slider
    this.dom.$slider.on('beforeChange', (e, s, c, next) => {
      this.dom.$sliderContent.slick('slickGoTo', next)
      this.createPagination(next)
    })
    // Create content slider
    this.dom.$sliderContent.slick({
      infinite: true,
      dots: false,
      arrows: false,
      draggable: false,
      slidesToShow: 1,
      slidesToScroll: 1

    })
  }

  createPaginationHTML(arr, active) {
    return arr.map(value => (
      value === 'spacer'
        ? '<span>...</span>'
        : `<button type="button" data-modal-index=${value} class="${active===value ? 'active' : ''}">${value+ 1}</button>`
    )).join('');
  }

  createPagination(currentSlide) {
    const pages = Array.from(this.dom.$sliderSlides).map((_, index) => index);
    const pagesLength = pages.length;
    const paginationContainer = this.dom.$dotsContainer;
    let paginationHtml = '';
    if (pagesLength <= 7) { // 7 or less
      paginationHtml = this.createPaginationHTML(pages, currentSlide)
    } else if (pagesLength > 7 && currentSlide < 5) { // more than 7 first 5 pages
      paginationHtml = this.createPaginationHTML([...pages.slice(0, 5), 'spacer', pages[pagesLength - 1]], currentSlide)
    } else if (pagesLength > 7 && currentSlide >= 5 && currentSlide <= pagesLength - 6) { //more than 7 after 5 pages but less than 5 pages to end
      paginationHtml = this.createPaginationHTML([
        pages[0],
        'spacer',
        currentSlide === 5 ? pages[currentSlide] : pages[currentSlide - 1],
        currentSlide === 5 ? pages[currentSlide + 1] : pages[currentSlide],
        currentSlide === 5 ? pages[currentSlide + 2] : pages[currentSlide + 1],
        'spacer',
        pages[pagesLength - 1]
      ], currentSlide)
    } else if (pagesLength > 7 && currentSlide >= 5 && currentSlide > pagesLength - 6){ // more than 5 last 5 pages
      paginationHtml = this.createPaginationHTML([
        pages[0],
        'spacer',
        ...pages.slice(pagesLength-5, pagesLength)
      ], currentSlide)
    }
    paginationContainer.html(paginationHtml)
    paginationContainer.find('button').click(e => (
      this.dom.$slider.slick('slickGoTo', e.currentTarget.dataset.modalIndex)
    ));
  }
}

export default BeforeAfter;



// WEBPACK FOOTER //
// ./src/tc/js/components/BeforeAfter.js